<template>
  <div class="card">
    <slot />
  </div>
</template>
<script>
export default {};
</script>

<style scoped>
.card {
  padding: 1em;
  border: 1px solid #d7dae2;
  font-size: 16px;

}
</style>
